/**
 * Utilidades para manejo de datos de ubicación
 */

/**
 * Normaliza valores que pueden venir como objetos { id, nombre } o como strings
 * @param {string|object|null|undefined} value - Valor a normalizar
 * @returns {string} - String normalizado
 */
export const getNormalizedValue = (value) => {
	// Si viene un objeto { id, nombre }, extraer solo el nombre (string)
	if (value && typeof value === 'object' && value.nombre) {
		return value.nombre
	}
	// Si ya es string o null/undefined, devolverlo tal como está
	return value || ''
}

/**
 * Normaliza un objeto de ubicación completo
 * @param {object} ubicacion - Objeto ubicación que puede tener campos como objetos o strings
 * @returns {object} - Ubicación con todos los campos normalizados a strings
 */
export const normalizeUbicacion = (ubicacion) => {
	if (!ubicacion) return null

	return {
		...ubicacion,
		direccion: getNormalizedValue(ubicacion.direccion),
		barrio: getNormalizedValue(ubicacion.barrio),
		ciudad: getNormalizedValue(ubicacion.ciudad),
		departamento: getNormalizedValue(ubicacion.departamento),
		observaciones: getNormalizedValue(ubicacion.observaciones)
	}
}

/**
 * Formatea una dirección completa para mostrar
 * @param {object} ubicacion - Objeto ubicación
 * @returns {string} - Dirección formateada
 */
export const formatearDireccionCompleta = (ubicacion) => {
	if (!ubicacion) return ''

	const direccion = getNormalizedValue(ubicacion.direccion)
	const barrio = getNormalizedValue(ubicacion.barrio)
	const ciudad = getNormalizedValue(ubicacion.ciudad)

	const partes = [direccion, barrio, ciudad].filter(Boolean)
	return partes.join(', ')
}